var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.alerts'] = (function () {
    'use strict';

    const CONFIG = {
        COOKIE_PREFIX: "MauiCountyFCU_Alert",
        COOKIE_VALUE_DISMISSED: "Dismissed",
        COOKIE_VALUE_NOT_COLLAPSED: "NotCollapsed",
        COOKIE_VALUE_COLLAPSED: "Collapsed"
    };

    const initialize = (component) => {

        const alerts = component.querySelectorAll(".alert");
        alerts.forEach(alert => {
            const alertGuid = alert.getAttribute("data-guid");
            const cookieName = `${CONFIG.COOKIE_PREFIX}_${alertGuid}`;

            // attach click listener to the collapse button
            const buttonCollapse = alert.querySelector(".btn-collapse");
            if (buttonCollapse) {
                buttonCollapse.addEventListener("click", () => {
                    handleAlertCollapse(alert, buttonCollapse, cookieName);
                });
            }

            // attach close listener to the alert
            alert.addEventListener("closed.bs.alert", () => {
                handleAlertClose(cookieName);
            });
        });
    };

    const handleAlertCollapse = (alert, buttonCollapse, cookieName) => {

        const alertCollapsed = buttonCollapse.getAttribute("aria-expanded") === "false";
        buttonCollapse.setAttribute("aria-expanded", alertCollapsed ? "true" : "false");

        alert.classList.toggle("collapsed", !alertCollapsed);
        if (alertCollapsed) alert.setAttribute("role", "alert");
        else alert.removeAttribute("role");

        const collapsableStatus = alertCollapsed ? CONFIG.COOKIE_VALUE_NOT_COLLAPSED : CONFIG.COOKIE_VALUE_COLLAPSED;
        App.Cookies.setItem(cookieName, collapsableStatus, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
    };

    const handleAlertClose = (cookieName) => {
        App.Cookies.setItem(cookieName, CONFIG.COOKIE_VALUE_DISMISSED, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
    };

    return {
        initialize
    };

})();
